import { Jwt } from 'types/jwt';

export function decodeToken(encodedToken: string): Jwt {
  const base64Url = encodedToken.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64)) as Jwt;
}


// WEBPACK FOOTER //
// ./src/helpers/token-helper.ts